"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Heading from "./webflow_modules/Basic/components/Heading";
import Link from "./webflow_modules/Basic/components/Link";
import Paragraph from "./webflow_modules/Basic/components/Paragraph";

export function PropertyCardNoResults({ resetSearchRuntimeProps = {} }) {
  return (
    <Block className={"card---no-results"} tag={"div"}>
      <Block className={"no-results-copy"} tag={"div"}>
        <Block className={"no-results-heading"} tag={"div"}>
          <Heading className={"text-50"} tag={"h3"}>
            {"No homes Found "}
            <br />
            {"In this area"}
          </Heading>
        </Block>
        <Block className={"frame-215-copy"} tag={"div"}>
          <Link
            button={false}
            className={"frame-216"}
            options={{
              href: "#",
            }}
            {...resetSearchRuntimeProps}
          >
            <Paragraph className={"text-53"}>
              {"Expand Search Results"}
            </Paragraph>
          </Link>
        </Block>
      </Block>
    </Block>
  );
}
